import { render, staticRenderFns } from "./OnCallInputFields.vue?vue&type=template&id=23c3fd3c&"
import script from "./OnCallInputFields.vue?vue&type=script&lang=js&"
export * from "./OnCallInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports